/**
 * Application configuration.
 *
 * Backend server base URL. Override at build time with the
 * REACT_APP_API_BASE_URL environment variable (e.g. in .env / .env.local),
 * otherwise the production server is used.
 */
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://grmahler.pythonanywhere.com';
